module.exports = __webpack_public_path__ + "static/media/Steuart 2 + Spear 2 750x774.91014c07.png";